import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Broadcast: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 23.815 20.722"
    >
      <g id="Group_7567" data-name="Group 7567" transform="translate(1 1.392)">
        <ellipse
          id="Ellipse_38"
          data-name="Ellipse 38"
          cx="2.505"
          cy="2.505"
          rx="2.505"
          ry="2.505"
          transform="translate(8.403 6.464)"
          fill="currentColor"
        />
        <path
          id="Path_4164"
          data-name="Path 4164"
          d="M377.842,307.59a10.909,10.909,0,0,0,0,17.938"
          transform="translate(-373.142 -307.59)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_4165"
          data-name="Path 4165"
          d="M378.115,309.639a6.919,6.919,0,0,0-.661,10.366"
          transform="translate(-371.437 -306.177)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_4166"
          data-name="Path 4166"
          d="M385.346,307.59a10.91,10.91,0,0,1,0,17.938"
          transform="translate(-368.23 -307.59)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_4167"
          data-name="Path 4167"
          d="M384.279,309.639a6.921,6.921,0,0,1,.661,10.366"
          transform="translate(-369.14 -306.177)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default Broadcast;
